module.exports = __webpack_public_path__ + "static/media/1.42587034.gif";